import { render, staticRenderFns } from "./cardprLogo.vue?vue&type=template&id=1ccb83d8&"
import script from "./cardprLogo.vue?vue&type=script&lang=js&"
export * from "./cardprLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports